import { SxProps, Theme } from "@mui/material/styles";

export const syles = {
  cropsMenu: {
    width: "100%",
    display: "flex",
    marginTop: "10px",
    paddingBottom: "20px",
  },
  cropsSelector: {
    width: "100%",
    height: "56px",
    marginRight: "10px",
  },
  crops: {
    display: "flex",
    gap: 1,
    flexWrap: "wrap",
    justifyContent: "flex-start",
    alignItems: "flex-start",
  },
  cropChip: {
    height: 40,
    borderRadius: 1.5,
    fontSize: "0.875rem",
    "&.MuiChip-filled": {
      backgroundColor: "rgba(25, 118, 210, 0.12)",
      color: "#1976d2",
      borderColor: "#1976d2",
      borderWidth: 1.5,
      "&:hover": {
        backgroundColor: "rgba(25, 118, 210, 0.2)",
      },
    },
    "&.MuiChip-outlined": {
      borderWidth: 1.5,
      borderColor: "#d1d5db",
      "&:hover": {
        backgroundColor: "rgba(0, 0, 0, 0.04)",
      },
    },
    cursor: "pointer",
    transition: "all 0.2s ease-in-out",
  } as SxProps<Theme>,
  noDataMessage: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: 2,
    color: "#666",
    fontSize: "0.875rem",
    fontStyle: "italic",
    textAlign: "center",
  } as SxProps<Theme>,
};
